export default "__VITE_ASSET__120554a5__"